import _ from "lodash";

export const onHandleSwapBlockMediaIndex = ({
  type = "up",
  index,
  setBlockMediaList = () => undefined,
}) => {
  setBlockMediaList((prevList) => {
    const newList = [...prevList];
    if (type === "up" && index > 0) {
      [newList[index - 1], newList[index]] = [
        newList[index],
        newList[index - 1],
      ];
    } else if (type === "down" && index < _.size(newList) - 1) {
      [newList[index + 1], newList[index]] = [
        newList[index],
        newList[index + 1],
      ];
    }
    return newList;
  });
};
